import {QuoteEmailStyleApiDto} from "../../api/model/rest";

export default class QuoteEmailStyle {
	constructor(
		public readonly name: string,
		public readonly suffix: string,
		public readonly defaultStyle: boolean) {}

	static fromJson(json: QuoteEmailStyleApiDto): QuoteEmailStyle {
		return new QuoteEmailStyle(json.name, json.suffix, json.defaultStyle);
	}

}